<template>
    <div class="card-box">
        <div class="info-box">
            <img class="dancer-avatar" :src="thumb" alt="">
            <div class="name-box">
                <span>{{nick}}</span>
                <span class="add-time">{{$time(v.addtime)}}</span>
                <!--<span class="add-time">{{$time('2019-04-18 17:24:00')}}</span>-->
            </div>
        </div>
        <div class="content">
            <a :href="`/dancers/activities/${v.id}`" class="text" target="_blank">{{v.title}}</a>

            <img v-if="v.type === 1" :class="`${v.enlarge ? 'enlarge' : 'narrow'}-img`"
                 @click="$set(v, 'enlarge', !v.enlarge)" :src="v.thumb" :style="`width: ${v.enlarge ? 576 : 287}px;height: ${v.height / v.width * (v.enlarge ? 576 : 287)}px`" alt="">

            <div v-if="v.type === 2" class="proto-box">
                <base-player :options="options(v, false)"></base-player>
            </div>

            <div v-if="v.type === 3" :class="`media zoom-${v.media.length}`">
                <div v-show="v.enlarge === undefined" v-for="(vv, kk) in v.media"
                     :class="`preview-box${vv.is_video ? ' preview-video' : ''}`" @click="changeEnlarge(v, kk)">
                    <div class="preview-mask"></div>
                    <img class="cover" :src="vv.thumb" alt="">
                    <i v-if="vv.is_video" class="icon-movie"></i>
                    <i v-if="vv.is_video" class="icon-play"></i>
                </div>

                <div v-show="v.enlarge > -1">
                    <div class="proto-box">
                        <img v-if="!v.media[v.enlarge || 0].is_video" class="enlarge-img"
                             :src="v.media[v.enlarge || 0].thumb"
                             @click="v.enlarge = undefined" alt="">

                        <div v-if="v.media[v.enlarge || 0].is_video">
                            <base-player :options="options(v.media[v.enlarge || 0], v.enlarge > -1)"></base-player>
                        </div>

                        <div v-show="v.enlarge" class="prev-mask" @click="v.enlarge--"></div>
                        <div v-show="v.media.length !== v.enlarge + 1" class="next-mask" @click="v.enlarge++"></div>
                    </div>
                    <div class="slider-bar">
                        <div class="slider-border"
                             :style="`transform: translateX(${v.enlarge === undefined ? 0 : (58 * v.enlarge)}px)`"></div>
                        <!--<img class="slider-img slider-active" src="//i0.hdslb.com/bfs/album/ef2e5ff152d2c951d5be2e6d4dc44a1ed1306207.jpg@104w_104h_1e_1c.jpg">-->
                        <img v-for="(vv, kk) in v.media"
                             :class="`slider-img${v.enlarge === kk ? ' slider-active' : ''}`"
                             :src="vv.thumb" @click="changeEnlarge(v, kk)" alt="">
                    </div>
                </div>
            </div>


            <div class="bar">
                <div @click="collect(v)" :class="`bar-box${v.is_collect ? ' bar-active' : ''}`">
                    <div class="bar-icon" v-waves>
                        <i :class="v.is_collect ? 'icon-collected' : 'icon-collect'"></i>
                    </div>
                    {{v.is_collect ? '已' : ''}}收藏
                </div>
                <div :class="`bar-box ${v.showComment ? ' bar-active' : ''}`" @click="toggleComment">
                    <div class="bar-icon">
                        <i class="icon-comment"></i>
                    </div>
                    {{v.comments || '评论'}}
                </div>
                <div @click="like(v)" :class="`bar-box${v.is_like ? ' bar-active' : ''}`">
                    <div class="bar-icon" v-waves>
                        <i :class="v.is_like ? 'icon-liked' : 'icon-like'"></i>
                    </div>
                    {{v.likes || '喜欢'}}
                </div>
            </div>

            <div v-show="showComment" class="comment-box">
                <div v-show="!comments.length">
                    <div v-show="comment_loading" class="loading-box">
                        <i class="loading"></i>
                        正在加载中，请稍候...
                    </div>
                    <div v-show="comment_loading_error" @click="loadComment(v)" class="loading-box cp">
                        <span class="error-text">请求超时,</span>
                        <span class="dc"> 点击重新载入</span>
                    </div>
                </div>


                <div v-show="comments.length || (!comment_loading && !comment_loading_error)">
                    <div class="comment-header">
                        <div @click="loadComment(v)" :class="order_hot ? 'comment-title-box' : 'active'">
                            <div class="comment-title" v-waves>全部评论</div>
                        </div>
                        <div v-show="v.comments > 10" @click="loadComment(1)" :class="order_hot ? 'active' : 'comment-title-box'">
                            <div class="comment-title" v-waves>按热度排序</div>
                        </div>
                    </div>
                    <div class="comment-send">
                        <img class="comment-avatar" v-lazy="{src: user.thumb ? user.thumb.replace(/http:/, '') : 'https://img.vhiphop.top/icon/a.png', error: 'https://img.vhiphop.top/icon/a.png', loading: 'https://img.vhiphop.top/icon/a.png'}" alt="">
                        <div class="comment-area-box">
                            <base-area :show="v.area" @send="sendComment" v-model="topComment"></base-area>
                        </div>
                    </div>
                </div>

                <div v-if="comments.length">
                    <div v-for="w in comments" :key="w.id" :class="`comment-list${w.rcount ? ' no-border' : ''}`">
                        <img class="comment-avatar" :src="w.thumb" alt="">
                        <div class="comment-main">
                            <div>
                                <span class="comment-nickname">{{w.nico}}</span>
                                <p class="comment-content">{{w.content}}</p>
                                <div class="comment-tool">
                                    <span class="comment-tool-action">{{$time(w.addtime)}}</span>
                                    <!--<span class="comment-tool-action">{{$time('2019-04-18 18:11:00')}}</span>-->
                                    <span @click="likeComment(w, true)" :class="`comment-tool-action action-hover${w.is_like ? ' action-active' : ''}`">
                                            <i :class="`icon-zan${w.is_like ? '-fill' : ''}`"></i> {{w.likes || ''}}
                                        </span>
                                    <span class="comment-tool-action action-hover" @click="showEditor(w)">回复</span>
                                </div>
                            </div>
                            <div v-show="w.area" class="comment-area-box">
                                <base-area :show="w.area" @send="replyTop(w)" v-model="comment[w.id]"></base-area>
                            </div>
                            <div v-if="w.replies.length" class="reply-box">
                                <div class="comment-list" v-for="x in w.replies" :key="x.id">
                                    <div class="reply-main">
                                        <div class="reply-content-box">
                                            <span class="comment-nickname">{{x.nico}}</span>
                                            <div>
                                                    <span v-if="!x.is_direct" >
                                                        ：回复<span class="user-name"> @{{x.pnico}}</span>
                                                    </span>：{{x.content}}
                                            </div>
                                        </div>
                                        <div class="comment-tool">
                                            <span class="comment-tool-action">{{$time(x.addtime)}}</span>
                                            <span @click="likeComment(x)" :class="`comment-tool-action action-hover${x.is_like ? ' action-active' : ''}`">
                                                    <i :class="`icon-zan${x.is_like ? '-fill' : ''}`"></i> {{x.likes || ''}}
                                                </span>
                                            <span @click="showEditor(x)" class="comment-tool-action action-hover">回复</span>
                                        </div>
                                        <div v-show="x.area" class="comment-area-box">
                                            <editor :placeholder="`回复 @${x.nico}：`" :show="x.area" @send="sendReply(w, x)" v-model="reply[x.id]"></editor>
                                        </div>
                                    </div>
                                </div>
                                <a v-if="w.rcount > 2" :href="`/dancers/activities/${v.id}`" target="_blank" class="comment-link">共{{w.rcount}}条评论</a>
                            </div>
                        </div>
                    </div>
                    <a v-if="v.comments > comments.length" :href="`/dancers/activities/${v.id}`" target="_blank" class="more-link">查看更多 &gt;</a>
                </div>
            </div>


        </div>
    </div>
</template>

<script>
    export default {
        props: {
            nick: String,
            thumb: String,
            v: Object,
        },
        data: () => ({
            enlarge: [],
            comments: [],
            comment_sending: false,
            comment_loading: false,
            comment_loading_error: false,
            showComment: false,
            topComment: '',// 顶级评论内容
            comment: [],// 顶级评论的回复内容
            reply: [],// 二级评论的回复内容
            area: false,
            order_hot: 0,
        }),
        computed: {
            id() {
                return this.$route.params.id;
            },
            state() {
                return this.$store.state;
            },
            video() {
                return this.state.video;
            },
            user() {
                return this.state.user;
            },
            sign() {
                return this.state.sign;
            },
            uid() {
                return this.user.id;
            },
        },

        methods: {
            async like(v) {
                if (v.is_liking) return;
                if (!this.uid) return this.sign.sign_box_show = true;

                v.is_liking = true;

                if (v.is_like) {// 点赞
                    v.likes--;
                    v.is_like = false;
                    await this.api.del(`dancers/activities/${v.id}/likes`).catch(e => {
                        this.alert.err(e.message);
                        v.v.likes++;
                        v.is_like = true;
                    });
                } else {// 取消点赞
                    v.likes++;
                    v.is_like = true;
                    await this.api.post(`dancers/activities/${v.id}/likes`).catch(e => {
                        this.alert.err(e.message);
                        v.likes--;
                        v.is_like = false;
                    });
                }

                v.is_liking = false;
            },
            async collect(v) {
                if (v.is_collecting) return;
                if (!this.uid) return this.sign.sign_box_show = true;

                v.is_collecting = true;

                if (v.is_collect) {// 点赞
                    v.is_collect = false;
                    await this.api.del(`dancers/activities/${v.id}/collect`).catch(e => {
                        this.alert.err(e.message);
                        v.is_collect = true;
                    });
                } else {// 取消点赞
                    v.is_collect = true;
                    await this.api.post(`dancers/activities/${v.id}/collect`).catch(e => {
                        this.alert.err(e.message);
                        v.is_collect = false;
                    });
                }

                v.is_collecting = false;
            },
            async likeComment(v, isTop = false) {
                if (v.is_liking) return;
                if (!this.uid) return this.sign.sign_box_show = true;

                v.is_liking = true;
                const comment = isTop ? 'comment' : 'reply';

                if (v.is_like) {// 点赞
                    v.likes--;
                    v.is_like = false;
                    await this.api.del(`dancers/activities/${comment}/${v.id}/likes`).catch(e => {
                        this.alert.err(e.message);
                        v.likes++;
                        v.is_like = true;
                    });
                } else {// 取消点赞
                    v.likes++;
                    v.is_like = true;
                    await this.api.post(`dancers/activities/${comment}/${v.id}/likes`).catch(e => {
                        this.alert.err(e.message);
                        v.likes--;
                        v.is_like = false;
                    });
                }

                v.is_liking = false;
            },
            options: (v, autoplay) => ({
                width: 576,
                height: v.height / v.width * 576,
                fluid: false,
                autoplay: autoplay, //如果true,浏览器准备好时开始播放。 enlarge > -1
                sources: [{
                    type: 'video/mp4',
                    src: v.src //url地址
                }],
                poster: v.thumb, //你的封面地址
            }),
            changeEnlarge(v, kk) {
                this.$set(v, 'enlarge', kk);
            },
            toggleComment() {
                if (this.showComment) {
                    this.showComment = false;
                    return this.area = false;
                }
                this.showComment = true;
                this.loadComment();
            },
            async loadComment(order_hot = 0) {
                if (this.comment_loading) return;
                this.comment_loading = true;
                this.order_hot = order_hot;

                this.comments = await this.api.get(`dancers/activities/${this.v.id}/comments/simple`, {order_hot}).catch(e => {
                    this.alert.err(e.message);
                    this.comment_loading_error = true;
                });
                this.area = true;
                this.comment_loading = false;
            },
            sendComment() {
                const content = this.topComment;
                if (!content || content.length > 233) return this.alert.err('评论内容必须在1~233字之间');

                if (this.comment_sending) return;
                this.comment_sending = true;

                this.api.post(`dancers/activities/${this.v.id}/comments`, {content}).then(e => {
                    this.comments.unshift({
                        id: e,
                        user_id: this.uid,
                        nico: this.user.nico,
                        thumb: this.user.thumb,
                        content,
                        addtime: '刚刚',
                        likes: 0,
                        is_like: false,
                        rcount: 0,
                        replies: []
                    });

                    this.comment_sending = this.topComment = '';
                    this.v.comments++;
                }, e => {
                    this.comment_sending = false;
                    this.alert.err(e.message);
                })
            },
            replyTop(comment) {
                const content = this.comment[comment.id], is_direct = 1, pid = comment.user_id;
                if (!content || content.length > 233) return this.alert.err('评论内容必须在1~233字之间');

                if (comment.comment_sending) return;
                this.$set(comment, 'comment_sending', true);

                this.api.post(`dancers/activities/${this.v.id}/replies`, {content, is_direct, tid: comment.id, pid}).then(e => {
                    comment.replies.unshift({
                        id: e,
                        user_id: this.uid,
                        nico: this.user.nico,
                        thumb: this.user.thumb,
                        content,
                        addtime: '刚刚',
                        likes: 0,
                        is_like: false,
                        is_direct,
                    });
                    comment.comment_sending = comment.area = false;// 子组件接受boolean
                    comment.comment = '';
                    comment.rcount++;
                    this.v.comments++;
                }, e => {
                    comment.comment_sending = false;
                    this.alert.err(e.message);
                })
            },
            sendReply(comment, reply) {
                const content = this.reply[reply.id], pid = reply.user_id;
                if (!content || content.length > 233) return this.alert.err('评论内容必须在1~233字之间');

                if (reply.comment_sending) return;
                this.$set(reply, 'comment_sending', true);

                this.api.post(`dancers/activities/${this.v.id}/replies`, {content, tid: comment.id, pid, p_content_id: reply.id}).then(e => {
                    comment.replies.unshift({
                        id: e,
                        user_id: this.uid,
                        nico: this.user.nico,
                        thumb: this.user.thumb,
                        content,
                        addtime: '刚刚',
                        likes: 0,
                        is_like: false,
                        pid,
                        pnico: reply.nico,
                    });
                    reply.comment_sending = reply.area = false;
                    reply.comment = '';
                    comment.rcount++;
                    this.v.comments++;
                }, e => {
                    reply.comment_sending = false;
                    this.alert.err(e.message);
                })
            },
            showEditor(v) {
                this.$set(v, 'area', !v.area);
            }
        },
    }
</script>

<style scoped>
    @import "../../../static/css/common/comment.css";
    @import "../../../static/css/views/dancer/activity.css";
</style>



// WEBPACK FOOTER //
// src/views/dancer/ActivityOperate.vue